import AContainer from '../../library/ExtendedObjects/AContainer.js';

export default class Preloader_Rockets extends AContainer
{
    constructor(scene)
    {
        super(scene);

        this.radius = 200;
        this.rocketSpeed = .45;
        this.spawnDotDelay = 20;

        this.dotContainer = this.scene.addContainer(0, 0, new Phaser.GameObjects.Container(this.scene, 0, 0), this);
        this.theta = 0;
        this.curTime = 0;
        
        this.isRotating = false;
        this.isSpawning = true;

        this.rocketImage_1 = this.create(-this.scene.mid.x -100, this.radius, 'Preloader_Ship.png', 'preloader');
        this.rocketImage_2 = this.create(this.scene.mid.x + 100, -this.radius, 'Preloader_Ship.png', 'preloader');

        this.rocketImage_1.angle = 90;
        this.rocketImage_2.angle = -90;
    }

    preUpdate(time, delta)
    {
        this.curTime += delta;

        if(this.isSpawning) this.spawnRockets(delta);
        if(this.isRotating) this.positionRockets(delta);

        if(this.curTime >= this.spawnDotDelay)
        {
            this.spawnDots();
            this.curTime = 0;
        }
    }

    spawnRockets(delta)
    {
        this.rocketImage_1.x += delta * this.rocketSpeed;
        this.rocketImage_2.x -= delta * this.rocketSpeed;

        if(this.rocketImage_2.x <= 0)
        {
            this.isRotating = true;
            this.isSpawning = false;
        }
    }

    positionRockets(delta)
    {
        this.theta += .002 * delta;

        let x = Math.sin(this.theta) * this.radius;
        let y = Math.cos(this.theta) * this.radius;

        this.rotateRocket(x, y, this.rocketImage_1, 1);
        this.rotateRocket(x, y, this.rocketImage_2, -1);
    }

    rotateRocket(x, y, rocket, multiplier)
    {
        rocket.x = x * multiplier;
        rocket.y = y * multiplier;
        rocket.angle = ((-this.theta + 1.6) * Phaser.Math.RAD_TO_DEG) - (90-(90 * multiplier));
    }

    spawnDots()
    {
        this.spawnDot(this.rocketImage_1);
        this.spawnDot(this.rocketImage_2);
    }

    spawnDot(rocket)
    {
        let dot = this.scene.addCirc(rocket.x, rocket.y, 2, 0xf8a501, this.dotContainer);
        this.scene.addTween(dot, 1500, { alpha: 0 }, Phaser.Math.Easing.Linear, () => {
            dot.destroy();
        });
    }
}